<template>
    <div :class="changestyle?'vipTipBox vipTipBoxOther':'vipTipBox'" v-if="isVip&&!tipshow">
        <div class="vipTit">独家原创功能·功能上新 : 图片一键转视频</div>
        <div class="vipTitext">图片转视频是永久会员的专属功能，升级永久会员后即可使用</div>
        <video autoplay muted loop class="vipVideo" src="./videos/mgTip.mp4" preload="none">
        </video>
        <div class="vipCloseBtn" @click="closeViptip">关闭提醒 ( {{ vipTipCloseTime }} S )</div>
        <div class="triangleLeft" v-show="changestyle"></div>
        <div class="viptipRow" v-show="!changestyle">
            <img src="./img/vipTipRow.png" alt="">
        </div>
    </div>
</template>

<script>
    export default {
        props:['tipshow',"changestyle"],
        data(){
            return{
                timer:null,
                isVip:false,
                vipTipCloseTime: 5,
            }
        },
        mounted(){
            this.checkVisibility()
        },
        methods:{
            bgginCountDown() {
                this.timer = setInterval(() => {
                    this.vipTipCloseTime--
                    if (this.vipTipCloseTime <= 0) {
                        clearInterval(this.timer)
                        this.isVip = false
                        localStorage.setItem('vipMgTip',1)
                    }
                }, 1000);
            },
            closeViptip() {
                clearInterval(this.timer)
                this.isVip = false
                localStorage.setItem('vipMgTip',1)
            },
            checkVisibility() {
                if(!localStorage.getItem('vipMgTip')){
                    // setTimeout(() => {        
                        // const scrollContainer = document.querySelector('.draw_scroll') // 滚动容器
                        // const box = document.querySelector('.mgBox')
                        // const boxRect = box.getBoundingClientRect();
                        // const containerRect = scrollContainer.getBoundingClientRect();
                        // // 判断 mgBox 是否在 draw_scroll 可视范围内
                        // const isVisible =
                        //     boxRect.bottom > containerRect.top && boxRect.top < containerRect.bottom;
                        //     this.isVip = isVisible?false:true
                            this.isVip = true
                            this.bgginCountDown()
                    // },1500);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
.vipTipBox {
    width: 384px;
    height: 395px;
    position: absolute;
    top: -520px;
    left: 278px;
    // background: #fff;
    // background: linear-gradient(to bottom, rgb(54, 58, 94), rgb(43, 52, 64));
    border-radius: 8px;
    padding: 0 30px;
    background: 
    linear-gradient(to bottom, rgba(77, 77, 77, 0.2), rgb(43, 52, 64)), 
    url('./img/mgTipBg.png');
    background-size: cover;  /* 使背景图片自适应 */
    // background-size: auto;
    // background-position: center; /* 背景图片居中 */
    background-repeat: no-repeat; /* 背景图片不平铺 */
    // overflow: hidden;
    .viptipRow{
        width: 140px;
        height: 100px;
        position: absolute;
        bottom: -140px;
        left: 0px;
        // transform: translateX(-50%);
    }

    .vipTit {
        font-size: 16px;
        color: #fff;
        margin-top: 20px;
        font-weight: 400;
    }

    .vipTitext {
        font-size: 14px;
        color: #fff;
        margin-top: 16px;
        line-height: 20px;
        font-weight: 300;
    }

    .vipVideo {
        border-radius: 15px;
        width: 330px;
        height: 185px;
        margin-top: 30px;
    }

    .vipCloseBtn {
        width: 326px;
        height: 40px;
        border-radius: 40px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        color: #000;
        margin-top: 22px;
        background: linear-gradient(to right, rgb(166, 255, 29), rgb(72, 212, 253));
    }

    .triangleLeft {
        width: 0;
        height: 0;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-right: 6px solid rgb(43, 52, 64);
        position: absolute;
        bottom: 15px;
        left: -6px;
    }

}
.vipTipBoxOther{
    top: -311px;
    left: 308px;
}
</style>